import { Sidebar } from '@agro1desenvolvimento/react-components';
import { useSelector, useDispatch } from 'react-redux';
import { FC, PropsWithChildren } from 'react';
import {
  hideSideBarRight,
  selectSideBarRightState,
} from './sidebar-right-slice';

const Icons: FC<{ header?: string }> = ({ header }) => (
  <h2 className="header">{header}</h2>
);

const SideBarRight: React.FC<PropsWithChildren<{ header?: string }>> = ({
  children,
  header,
}) => {
  const dispatch = useDispatch();
  const { visible } = useSelector(selectSideBarRightState);
  return (
    <Sidebar
      visible={visible}
      position="right"
      onHide={() => dispatch(hideSideBarRight())}
      className="col-4 sidebar"
      icons={<Icons header={header} />}
    >
      {children}
    </Sidebar>
  );
};

export default SideBarRight;
